export const getAmplitudePaymentDetailsProvider = (isChainProxy: boolean, isProxy: boolean) => {
  if (isChainProxy) {
    return 'reassigned_recipient';
  }

  return isProxy ? 'proxy' : 'direct_recipient';
};
